import Model from './interface/Model'

export default class TenantSharedModel extends Model {
  protected api_settings = {
    save_mode: 'form',
    paths: {
      singular: 'tenant_shared_model' as string | null,
      plural: 'tenant_shared_models' as string | null,
    },
  }

  public id: string = ''

  public tenant_id: string = ''

  public tenant_owner_id: string = ''

  public model_type: string = ''

  public model_id: string = ''

  public model_name: string = ''

  public settings: any = {}

  public status: string = 'active'

  public get apiData() {
    return {
      tenant_id: this.tenant_id,
      tenant_owner_id: this.tenant_owner_id,
      model_type: this.model_type,
      model_id: this.model_id,
      settings: this.settings,
      status: this.status,
    }
  }

  public toObject(source: any) {
    let instance = this.clone()

    Object.assign(instance, source)

    return instance
  }

  public get formName(): string {
    return this.settings.name || ''
  }

  public set formName(value: string) {
    this.settings.name = value
  }

  public get formRate(): number {
    return this.settings.rate || 0
  }

  public set formRate(value: number) {
    this.settings.rate = value
  }

  public get status_color(): string {
    if (this.status === 'active') {
      return 'success'
    }
    if (this.status === 'inactive') {
      return 'danger'
    }
    return 'warning'
  }
}
